export default __webpack_public_path__ + "static/media/file.4bf87ae0.xlsx";